// Confirms the file is loaded
console.log('[dd-wishlist] loaded');

// Toggle the PDP star on click + log the item data (no storage yet)
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.dd-wishlist-btn');
  if (!btn) return;

  e.preventDefault();

  // keep the visual toggle you already have
  const nowActive = btn.classList.toggle('is-active');
  btn.setAttribute('aria-pressed', nowActive ? 'true' : 'false');

  // NEW: read the data- attributes so we can verify what we'll save later
  const item = {
    id:     btn.dataset.productId,
    handle: btn.dataset.productHandle || '',
    title:  btn.dataset.productTitle  || '',
    url:    btn.dataset.productUrl    || '',
    image:  btn.dataset.productImage  || ''
  };

  console.log('[wishlist 2A]', nowActive ? 'ADD →' : 'REMOVE →', item);
});

// — Header dot: sync from localStorage on load, and render the list
function ddSyncHeaderDot() {
  let list = [];
  try { list = JSON.parse(localStorage.getItem('dd_wishlist_v1')) || []; } catch (e) {}
  const hasItems = list.length > 0;

  // toggle class on the header link(s)
  document.querySelectorAll('[data-dd-wishlist-link]').forEach(el => {
    el.classList.toggle('has-items', hasItems);
  });

  // show/hide the dot(s)
  document.querySelectorAll('[data-dd-wishlist-dot]').forEach(dot => {
    dot.hidden = !hasItems;
  });
}

// call once on load (and try to render the table)
document.addEventListener('DOMContentLoaded', () => {
  ddSyncHeaderDot();
  if (typeof renderWishlist === 'function') renderWishlist();
});

// call after a wishlist button click (let the toggle finish, then sync + render)
document.addEventListener('click', (e) => {
  if (e.target.closest('.dd-wishlist-btn')) {
    setTimeout(() => {
      ddSyncHeaderDot();
      if (typeof renderWishlist === 'function') renderWishlist();
    }, 0);
  }
});



/* === dd-wishlist: store/remove item in localStorage on click === */
(function () {
  const STORAGE_KEY = 'dd_wishlist_v1';

  const getList = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  };
  const saveList = (list) => localStorage.setItem(STORAGE_KEY, JSON.stringify(list));

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.dd-wishlist-btn');
    if (!btn) return;

    // build the item from data-attributes already on the button
    const item = {
      id: btn.dataset.productId,
      variantId: btn.dataset.variantId || '',
      handle: btn.dataset.productHandle || '',
      title: btn.dataset.productTitle || '',
      url: btn.dataset.productUrl || '',
      image: btn.dataset.productImage || ''
    };

    // use the existing visual state to decide add/remove
    const nowActive = btn.classList.contains('is-active');
    let list = getList();

    if (nowActive) {
      // add if not already in list
      if (!list.some(p => String(p.id) === String(item.id))) list.push(item);
    } else {
      // remove if it’s there
      list = list.filter(p => String(p.id) !== String(item.id));
    }

    saveList(list);
    console.log('[wishlist 3] list -->', list);
  });
})();

// --- Hydrate PDP star from localStorage on load ---
function ddHydratePDPStar() {
  const btn = document.querySelector('.dd-wishlist-btn');
  if (!btn) return;

  let list = [];
  try { list = JSON.parse(localStorage.getItem('dd_wishlist_v1') || '[]'); } catch (e) {}

  const isActive = list.some(p => String(p.id) === String(btn.dataset.productId));
  btn.classList.toggle('is-active', isActive);
  btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
}

// run on initial load and when Shopify re-renders a section
document.addEventListener('DOMContentLoaded', ddHydratePDPStar);
document.addEventListener('shopify:section:load', ddHydratePDPStar);

// --- Header dot: sync from localStorage on load ---
function ddGetWishlist() {
  try { return JSON.parse(localStorage.getItem('dd_wishlist_v1')) || []; }
  catch (e) { return []; }
}

function ddSyncHeaderFromStorage() {
  const hasItems = ddGetWishlist().length > 0;
  document.querySelectorAll('[data-dd-wishlist-link]').forEach(el => {
    el.classList.toggle('has-items', hasItems);
  });
  document.querySelectorAll('[data-dd-wishlist-dot]').forEach(dot => {
    dot.hidden = !hasItems;
  });
}

document.addEventListener('DOMContentLoaded', ddSyncHeaderFromStorage);

// call once on load
document.addEventListener('DOMContentLoaded', renderWishlist);

// ------ Render wishlist ------
function renderWishlist () {
  // read items from localStorage
  let items = [];
  try { items = JSON.parse(localStorage.getItem('dd_wishlist_v1')) || []; } catch (e) {}

  // helper to support either id style: #ddw-* or #dd-w-*
  const pick = (...sels) => sels.map(s => document.querySelector(s)).find(Boolean);

  const body  = pick('#ddw-body',  '#dd-w-body');
  const table = pick('#ddw-table', '#dd-w-table');
  const empty = pick('#ddw-empty', '#dd-w-empty');
  const tpl   = pick('#ddw-row',   '#dd-w-row');

  // if the markup isn't on the page, bail
  if (!body || !table || !empty || !tpl) {
    console.warn('Wishlist markup not found', { body: !!body, table: !!table, empty: !!empty, tpl: !!tpl });
    return;
  }

  // show/hide empty vs table
  empty.hidden = items.length > 0;
  table.hidden = !(items.length > 0);

  // reset rows
  body.innerHTML = '';

  // build rows
  items.forEach(it => {
    const row = tpl.content.firstElementChild.cloneNode(true);

    const linkEl = row.querySelector('.dd-w-link');
    if (linkEl) linkEl.href = it.url;

    const imgEl = row.querySelector('.dd-w-img');
    if (imgEl) { imgEl.src = it.image; imgEl.alt = it.title || ''; }

    const titleEl = row.querySelector('.dd-w-title');
    if (titleEl) { titleEl.textContent = it.title || ''; titleEl.href = it.url; }

    const priceEl = row.querySelector('.dd-w-price');
    if (priceEl && it.price) priceEl.textContent = it.price;

const addBtn = row.querySelector('.dd-w-add');
if (addBtn) {
  addBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    try {
      // 1) Derive the product handle from the URL we already have
      // it.url looks like "/products/audrey-ruby-bracelet"
      const handle = (it?.url || '').split('/products/')[1]?.split('?')[0];
      if (!handle) {
        // No handle? fall back to product page
        window.location.href = it?.url || '/';
        return;
      }

      // 2) Fetch product JSON to get a REAL variant id
      const prodRes = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } });
      if (!prodRes.ok) throw new Error('Product JSON fetch failed');
      const product = await prodRes.json();

      // pick the first available variant (or just first if none available flagged)
      const variant =
        product.variants?.find(v => v.available) ||
        product.variants?.[0];

      if (!variant?.id) throw new Error('No variant id found');

      // 3) Add to cart using the variant id
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
      if (!addRes.ok) {
        const err = await addRes.text().catch(() => '');
        throw new Error(`Add failed: ${err}`);
      }

      // 4) Go to cart (simple baby step). We can do a toast later if you want to stay on page.
      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      // Fallback: send to product page so the customer can pick a variant manually
      window.location.href = it?.url || '/';
    }
  });
}



// Remove from wishlist
const remBtn = row.querySelector('.dd-w-remove');
if (remBtn) {
  remBtn.addEventListener('click', () => {
    // Remove from localStorage immediately
    let list = [];
    try { list = JSON.parse(localStorage.getItem('dd_wishlist_v1')) || []; } catch (e) {}
    list = list.filter(itm => itm.id !== it.id);
    localStorage.setItem('dd_wishlist_v1', JSON.stringify(list));

    // Remove from DOM
    row.remove();

    // Update UI state
    const body = document.querySelector('#dd-body');
    const table = document.querySelector('#dd-table');
    const empty = document.querySelector('#dd-empty');
    if (!body.children.length) {
      empty.hidden = false;
      table.hidden = true;
    }
  });
}


    body.appendChild(row);
  });
}
